import styled, { css } from 'styled-components';

import { hexToRgba } from '~/common/utils/hex-to-rgba';
import { SPACING } from '~/common/constants/spacing';
import { RADIUS } from '~/common/constants/border-radius';

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${SPACING._16};
`;

export const VersionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  width: 100%;
  list-style: none;
`;

export const VersionItem = styled.li<{ $isOpen: boolean }>`
  border-radius: ${RADIUS._8};
  border: 1px solid
    ${({ theme, $isOpen }) =>
      $isOpen ? hexToRgba(theme.primary, 0.4) : theme.neutral[900]};
  background-color: ${({ theme }) => theme.neutral[950]};
  overflow: hidden;
  transition: 200ms;
`;

export const VersionChevron = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: 200ms;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
`;

export const VersionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 2px;

  span {
    display: block;
    overflow-wrap: anywhere;
  }
`;

export const VersionHeader = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: ${SPACING._12};
  width: 100%;
  padding: ${SPACING._12} ${SPACING._16};
  border: none;
  background-color: ${({ theme }) => theme.transparent};
  text-align: left;
  cursor: pointer;
  transition: 200ms;

  ${({ $isOpen, theme }) =>
    $isOpen &&
    css`
      background-color: ${hexToRgba(theme.primary, 0.08)};
    `}

  &:hover {
    background-color: ${({ theme }) => hexToRgba(theme.primary, 0.12)};
  }
`;

/** Etiqueta "Atual" no topo da versão mais recente. */
export const CurrentTag = styled.div`
  flex-shrink: 0;
  padding: 2px ${SPACING._8};
  border-radius: ${RADIUS._999};
  background-color: ${({ theme }) => hexToRgba(theme.primary, 0.18)};
  border: 1px solid ${({ theme }) => hexToRgba(theme.primary, 0.45)};
`;

export const ItemList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._12};
  padding: ${SPACING._4} ${SPACING._16} ${SPACING._16};
  list-style: none;
`;

export const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING._10};
`;

/** Badge [NOVIDADE] / [CORREÇÃO] — a cor vem do tipo do item. */
export const ItemBadge = styled.div<{ $color: string }>`
  flex-shrink: 0;
  /* alinha o badge com a primeira linha do título, não com o centro do bloco */
  margin-top: 1px;
  padding: 2px ${SPACING._8};
  border-radius: ${RADIUS._4};
  background-color: ${({ $color }) => hexToRgba($color, 0.16)};
  border: 1px solid ${({ $color }) => hexToRgba($color, 0.45)};
  white-space: nowrap;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 2px;

  span {
    display: block;
    overflow-wrap: anywhere;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const EmptyVersions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING._24} ${SPACING._16};
  text-align: center;
`;
